import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Heart, ArrowRight } from 'lucide-react';
import { API, C } from './ambApi';

export default function AmbassadorLanding() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const c = (code || '').toUpperCase();
    axios.get(`${API}/ambassador/public/${c}`)
      .then((r) => {
        setData(r.data);
        try {
          localStorage.setItem('referral_code', c);
          document.cookie = `referral_code=${c};path=/;max-age=${60 * 60 * 24 * 30}`;
        } catch (e) { /* ignore */ }
        axios.post(`${API}/ambassador/track-click`, { referral_code: c, landing_page: `/ambassador/${c}` }).catch(() => {});
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [code]);

  if (loading) return <div className="min-h-screen flex items-center justify-center" style={{ background: C.cream }}><Loader2 className="h-8 w-8 animate-spin" style={{ color: C.navy }} /></div>;
  if (notFound) return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center" style={{ background: C.cream }}>
      <p className="text-lg font-semibold" style={{ color: C.ink }}>This referral link isn't active.</p>
      <button onClick={() => navigate('/')} className="mt-4 px-6 h-11 rounded-full text-white font-semibold" style={{ background: C.navy }}>Go to EasyPassing</button>
    </div>
  );

  const name = `${data.first_name} ${data.last_name}`.trim();
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" style={{ background: `linear-gradient(160deg, ${C.cream} 0%, #ffffff 100%)` }} data-testid="ambassador-landing">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-[#EEECE8] p-8 text-center">
        <p className="text-sm font-bold tracking-wide" style={{ color: C.gold }}>EASYPASSING</p>
        <div className="mt-6 mb-4 flex justify-center">
          {data.profile_picture_url
            ? <img src={data.profile_picture_url} alt={name} className="w-24 h-24 rounded-full object-cover border-4" style={{ borderColor: C.cream }} data-testid="landing-avatar" />
            : <div className="w-24 h-24 rounded-full flex items-center justify-center text-white text-2xl font-bold" style={{ background: C.navy2 }}>{(data.first_name || '?')[0]}</div>}
        </div>
        <h1 className="text-xl font-bold" style={{ color: C.ink }}>{name} invited you 💛</h1>
        <p className="mt-3 text-[15px] leading-relaxed" style={{ color: '#4A5560' }}>{data.message}</p>
        <button data-testid="landing-get-started" onClick={() => navigate(`/login?ref=${data.referral_code}&mode=signup`)}
          className="mt-7 w-full h-12 rounded-full text-white font-semibold flex items-center justify-center gap-2" style={{ background: C.navy }}>
          Get Started Free <ArrowRight className="h-5 w-5" />
        </button>
        <p className="mt-4 text-xs" style={{ color: C.mute }}>Referral code <b>{data.referral_code}</b> will be applied automatically.</p>
      </div>
    </div>
  );
}
